<template>
    <v-card flat tile outlined color="primary" class="fill-height clickable" :class="{ 'outline': selected }" @click="select" v-track="{ category: 'Urgency and Impact', action: 'click', label: this.priority }">
        <v-card flat tile outlined color="white" class="px-3 fill-height">
            <v-row justify="center" align="center" class="fill-height hover" :class="{ selected: selected }">
                <v-col class="text-center">
                    <div class="display-1 font-weight-bold text-center">{{ count }}</div>
                    <div class="subtitle-1">{{ priority }}</div>
                </v-col>
            </v-row>
        </v-card>
    </v-card>
</template>

<script>
    import { filter } from 'lodash';

    export default {
        props: {
            priority: {
                type: String,
                required: true
            }
        },
        computed: {
            selected() {
                return this.$store.get('selectedPriority') === this.priority;
            },
            count() {
                return filter(this.$store.get('priorities'), { priority: this.priority }).length;
            }
        },
        methods: {
            select() {
                this.$store.set('selectedPriority', this.priority);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .clickable {
        cursor: pointer;
    }
    .hover:hover {
        background-color: rgba(128, 128, 128, 0.12);
    }
    .outline {
        padding: 2px;
    }
    .selected {
        background-color: rgba(128, 0, 128, 0.12);
        &:hover {
            background-color: rgba(128, 0, 128, 0.12);
        }
    }
</style>
